import SelectOption from "../@types/SelectOption"

const USStates: SelectOption[] = [
    {
        label: 'Alabama',
        value: ['Alabama', 'AL']
    },
    {
        label: 'Alaska',
        value: ['Alaska', 'AK']
    },
    {
        label: 'American Samoa',
        value: ['American Samoa', 'AS']
    },
    {
        label: 'Arizona',
        value: ['Arizona', 'AZ']
    },
    {
        label: 'Arkansas',
        value: ['Arkansas', 'AR']
    },
    {
        label: 'California',
        value: ['California', 'CA']
    },
    {
        label: 'Colorado',
        value: ['Colorado', 'CO']
    },
    {
        label: 'Connecticut',
        value: ['Connecticut', 'CT']
    },
    {
        label: 'Delaware',
        value: ['Delaware', 'DE']
    },
    {
        label: 'District of Columbia',
        value: ['District of Columbia', 'DC']
    },
    {
        label: 'Florida',
        value: ['Florida', 'FL']
    },
    {
        label: 'Georgia',
        value: ['Georgia', 'GA']
    },
    {
        label: 'Guam',
        value: ['Guam', 'GU']
    },
    {
        label: 'Hawaii',
        value: ['Hawaii', 'HI']
    },
    {
        label: 'Idaho',
        value: ['Idaho', 'ID']
    },
    {
        label: 'Illinois',
        value: ['Illinois', 'IL']
    },
    {
        label: 'Indiana',
        value: ['Indiana', 'IN']
    },
    {
        label: 'Iowa',
        value: ['Iowa', 'IA']
    },
    {
        label: 'Kansas',
        value: ['Kansas', 'KS']
    },
    {
        label: 'Kentucky',
        value: ['Kentucky', 'KY']
    },
    {
        label: 'Louisiana',
        value: ['Louisiana', 'LA']
    },
    {
        label: 'Maine',
        value: ['Maine', 'ME']
    },
    {
        label: 'Maryland',
        value: ['Maryland', 'MD']
    },
    {
        label: 'Massachusetts',
        value: ['Massachusetts', 'MA']
    },
    {
        label: 'Michigan',
        value: ['Michigan', 'MI']
    },
    {
        label: 'Minnesota',
        value: ['Minnesota', 'MN']
    },
    {
        label: 'Mississippi',
        value: ['Mississippi', 'MS']
    },
    {
        label: 'Missouri',
        value: ['Missouri', 'MO']
    },
    {
        label: 'Montana',
        value: ['Montana', 'MT']
    },
    {
        label: 'Nebraska',
        value: ['Nebraska', 'NE']
    },
    {
        label: 'Nevada',
        value: ['Nevada', 'NV']
    },
    {
        label: 'New Hampshire',
        value: ['New Hampshire', 'NH']
    },
    {
        label: 'New Jersey',
        value: ['New Jersey', 'NJ']
    },
    {
        label: 'New Mexico',
        value: ['New Mexico', 'NM']
    },
    {
        label: 'New York',
        value: ['New York', 'NY']
    },
    {
        label: 'North Carolina',
        value: ['North Carolina', 'NC']
    },
    {
        label: 'North Dakota',
        value: ['North Dakota', 'ND']
    },
    {
        label: 'Northern Mariana Islands',
        value: ['Northern Mariana Islands', 'MP']
    },
    {
        label: 'Ohio',
        value: ['Ohio', 'OH']
    },
    {
        label: 'Oklahoma',
        value: ['Oklahoma', 'OK']
    },
    {
        label: 'Oregon',
        value: ['Oregon', 'OR']
    },
    {
        label: 'Pennsylvania',
        value: ['Pennsylvania', 'PA']
    },
    {
        label: 'Puerto Rico',
        value: ['Puerto Rico', 'PR']
    },
    {
        label: 'Rhode Island',
        value: ['Rhode Island', 'RI']
    },
    {
        label: 'South Carolina',
        value: ['South Carolina', 'SC']
    },
    {
        label: 'South Dakota',
        value: ['South Dakota', 'SD']
    },
    {
        label: 'Tennessee',
        value: ['Tennessee', 'TN']
    },
    {
        label: 'Texas',
        value: ['Texas', 'TX']
    },
    {
        label: 'Utah',
        value: ['Utah', 'UT']
    },
    {
        label: 'Vermont',
        value: ['Vermont', 'VT']
    },
    {
        label: 'Virgin Islands',
        value: ['Virgin Islands', 'VI']
    },
    {
        label: 'Virginia',
        value: ['Virginia', 'VA']
    },
    {
        label: 'Washington',
        value: ['Washington', 'WA']
    },
    {
        label: 'West Virginia',
        value: ['West Virginia', 'WV']
    },
    {
        label: 'Wisconsin',
        value: ['Wisconsin', 'WI']
    },
    {
        label: 'Wyoming',
        value: ['Wyoming', 'WY']
    },
]

export default USStates;